<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <!-- <div class="modal-header">
            <h4 class="modal-title">Add User</h4>
          </div> -->
      <!-- Modal content-->
      <perfect-scrollbar class="modal-body-scrollbar">
        <div mat-dialog-content>
          <!-- Modal-Body -->
          <div class="modal-body br-8">
            <div class="modal_close_btn">
              <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
            </div>
            <div class="payment_details">
              <div class="status_img">
                <img src="../../../../../assets/images/icons/success.svg" alt="">
              </div>
              <div class="status_content">
                <h4>Please register as new user</h4>
                <!-- <div class="mt-20" fxLayout="column" fxLayoutAlign="center center">
                  <button class="btn btn-sm global-btn" mat-button>Continue</button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </perfect-scrollbar>
      <!-- Modal-Footer -->
      <!-- <div class="modal-footer">
            <div mat-dialog-actions class="modal_footer">
              <button mat-button (click)="dialogClose()" class="modal-cancel-btn modal-footer-btn">
                <span>Cancel</span>
              </button>
              <button mat-button class="modal-save-btn global-btn modal-footer-btn">
                <span>Save</span>
              </button>
            </div>
          </div> -->
    </div>
  </div>
</div>
